import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  balance: 0,
  hasSent: false, // restrict to one coin-send only
};

const coinSlice = createSlice({
  name: "coin",
  initialState,
  reducers: {
    addCoin: (state, action) => {
      state.balance += action.payload || 1;
    },
    markSent: (state) => {
      state.hasSent = true;
    },
  },
});

export const {   } = coinSlice.actions;

export default coinSlice.reducer;
